module.exports = __webpack_public_path__ + "img/环境3.bb109984.png";